import { useContext } from "react";
import { NavbarContext } from "../providers/navbar-provider.context";

export function useNavbar() {
  return useContext(NavbarContext);
}
